<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title"> {{'wizzard.title' | translate}}</span>
      <button mat-button class="mat-icon-button"
        (click)="dialogRef.close()"
        aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-24 m-0">
    <div class="info-modal">{{'birthday-wizard-info' | translate}}</div>
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            <th scope="col"> #</th>
            <th scope="col">{{'wizzard.name' | translate}}</th>
            <th scope="col" style="text-align: end;">{{'wizzard.currentTG' | translate}}      </th>
            <th scope="col" style="text-align: center;"></th>
            <th scope="col" style="text-align: start; width: 20%">{{'wizzard.newTG' | translate}}        </th>
            <th scope="col"> {{'wizzard.credits' | translate}}</th>
            <th scope="col"> {{'wizzard.transfer' | translate}}</th>
            <th scope="col"> {{'wizzard.last' | translate}}</th>
            <th>    <mat-checkbox [(ngModel)]="all" (change)="selectAll()"></mat-checkbox></th>
          </tr>
        </thead>

        <tbody>
          @for (item of users; track item; let i = $index) {
            <tr>
              <th scope="row">
                {{i + 1}}.
              </th>
              <td> <b>{{item.firstName + ' ' + item.lastName}}</b></td>
              <td style="    text-align: end;"> {{item.targetGroup ? item.targetGroup.ageMask : '-'}}</td>
              <td style="    text-align: center;"><i class="material-icons">
                arrow_right_alt
              </i></td>
              <td style="    text-align: start;"> {{item.nextTG ? item.nextTG.ageMask : '-'}} <i class="material-icons"
                style="vertical-align: middle;"
                (click)="openTgDialog(item.nextTG, i)">
                settings
              </i></td>
              <td [ngClass]="{'credit-done' : (item.totalCredit > (item.targetGroupSetting ? item.targetGroupSetting.creditTarget : 0)), 'credit-lose' : (item.totalCredit < (item.targetGroupSetting ? item.targetGroupSetting.creditTarget : 0))}"> <b>{{item.totalCredit + '/' + (item.targetGroupSetting ? item.targetGroupSetting.creditTarget : 0)}}</b></td>
              <td>
                @for (credit of item.transfer; track credit) {
                  <p style="width: 80%; display: inline-block">{{credit.name + ' - ' + credit.credit + ' credits'}}</p>
                }
                @if (item.transfer) {
                  <i class="material-icons"
                    (click)="openTransferDialog(item.transfer, i)">
                    settings
                  </i>
                }
              </td>
              <td>
                {{item.lastTimeChangeTG | date}}
              </td>
              <td>
                <mat-checkbox (change)="checkAll()" [(ngModel)]="item.selected"></mat-checkbox>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
  <div mat-dialog-actions class="action-button-dialog" style="margin: 1px">
    <button mat-raised-button    style="padding: 0px 10px;"  (click)="migrateUser()"  class="save-button mat-accent">{{'organization.confirm' | translate}}</button>
  </div>
</div>
@if (migrationInProcess) {
  <div class="migration-process">
    @if (!migrationSuccess && !migrationFailed) {
      <div class="in-progress">{{'organization.migration_progress' | translate}}:  {{migrationProgress.toFixed(1)}}%</div>
    } @else if (migrationSuccess) {
      <div class="success">{{'organization.migration_success' | translate}}</div>
      <div>{{'organization.update_in' | translate}}: {{countdown}}</div>
    } @else if (migrationFailed) {
      <div class="error">{{'organization.migration_failed' | translate}}</div>
      <div>{{'organization.update_in' | translate}}: {{countdown}}</div>
    }
  </div>
}
